/**
 * @module MessageKeys
 * @purpose Map a wire vocabulary code onto a namespaced i18n key, falling back to a
 *   generic key for anything not on the caller's whitelist.
 * @depends nothing (leaf module)
 * @dependedOnBy hooks/use-force-recompute.ts
 *
 * @rules
 * - Performance: pure function, no state
 * - State: n/a
 * - Errors: n/a -- never throws, always returns a key string
 */

const GENERIC_SUFFIX = 'generic'

/**
 * @behaviour Membership test against `whitelist`, never bare concatenation -- an
 *   unrecognised or absent code always resolves to `${prefix}.generic`, so a wire
 *   code the caller never enumerated cannot smuggle an arbitrary key path through.
 */
export function resolveMessageKey(
  code: string | undefined,
  whitelist: readonly string[],
  prefix: string,
): string {
  if (code !== undefined && whitelist.includes(code)) return `${prefix}.${code}`
  return `${prefix}.${GENERIC_SUFFIX}`
}
